import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconLock = (props: SvgIconProps) => (
    <ThemedFillSvgIcon {...props} viewBox="0 0 16 16">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
            <g clipPath="url(#clip0_3253_5503)">
                <path
                    d="M11.8003 12.386C11.7929 12.1085 11.787 11.8205 11.787 11.5252V6.9076C11.787 6.34655 11.3298 5.88939 10.7688 5.88939H10.4036V3.23998C10.4036 1.72899 9.17317 0.498535 7.66218 0.498535H4.15635C2.64388 0.500019 1.41491 1.73048 1.41491 3.24146V5.89088H1.04978C0.488724 5.89088 0.0315693 6.34803 0.0315693 6.90908V11.5266C0.0315693 11.8369 0.0226637 12.1382 0.0152424 12.4291C-0.0159272 13.5556 -0.042644 14.5278 0.472397 15.0577C0.761829 15.3546 1.20562 15.5 1.82902 15.5H9.9628C10.5892 15.5 11.0359 15.3546 11.3283 15.0547C11.8523 14.5174 11.8285 13.5304 11.8003 12.3875V12.386ZM2.73293 3.00101C2.73293 2.48003 3.15595 1.90859 3.67693 1.90859H8.1416C8.66258 1.90859 9.0856 2.48003 9.0856 3.00101V5.93095H2.73293V3.00101ZM5.90927 14.0974C4.08955 14.0974 2.60974 12.6176 2.60974 10.7979C2.60974 8.97815 4.08955 7.49834 5.90927 7.49834C7.72898 7.49834 9.20879 8.97815 9.20879 10.7979C9.20879 12.6176 7.72898 14.0974 5.90927 14.0974Z"
                    fill="#333333"
                />
                <path
                    d="M5.9088 8.32668C4.54625 8.32668 3.4375 9.43543 3.4375 10.798C3.4375 11.3294 3.60671 11.8236 3.89465 12.2258L7.33815 8.78235C6.93443 8.49589 6.44166 8.3252 5.91029 8.3252L5.9088 8.32668Z"
                    fill="#333333"
                />
                <path
                    d="M4.48 12.812C4.88372 13.0985 5.3765 13.2692 5.90786 13.2692C7.27042 13.2692 8.37917 12.1604 8.37917 10.7979C8.37917 10.2665 8.20996 9.77372 7.92201 9.37L4.47852 12.8135L4.48 12.812Z"
                    fill="#333333"
                />
            </g>
            <defs>
                <clipPath id="clip0_3253_5503">
                    <rect width="11.8118" height="15" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    </ThemedFillSvgIcon>
);
